import {Pipe, PipeTransform, Injectable} from '@angular/core';

@Pipe({name: 'monthstoyears'})
@Injectable()
export class MonthstoyearsPipe implements PipeTransform {
    transform(value: number, arg0?: string): any {
        if (value > 0) {
          const nummonths = Math.floor(value % 12);
          const numyears = Math.floor(value / 12);

          return `${numyears}${nummonths > 0 ? '.' + nummonths : '' } years`;
        } else {
          return '0 years';
        }
    }
}
